import './PaymentSettings.css';

/** Interruptor padrão das abas Pagamentos e Checkout. */
export function Switch({ checked, onChange, label, disabled = false }) {
    return (
        <span className="pset-switch">
            <input type="checkbox" role="switch" aria-label={label} checked={checked} disabled={disabled}
                onChange={(e) => onChange(e.target.checked)} />
            <span className="pset-switch-track" aria-hidden="true" />
        </span>
    );
}

/** Opção liga/desliga com título e explicação curta (clicar na linha alterna). */
export function OptionRow({ title, hint, checked, onChange, label = title }) {
    return (
        <label className="pset-option">
            <Switch checked={checked} onChange={onChange} label={label} />
            <span className="min-w-0">
                <span className="pset-option-title">{title}</span>
                {hint && <span className="pset-option-hint">{hint}</span>}
            </span>
        </label>
    );
}

/** Um bloco da tela: ícone, título, uma linha de explicação e o conteúdo. */
export default function PaymentSection({ icon: Icon, title, subtitle, aside, children }) {
    return (
        <section className="pset">
            <div className="pset-head">
                {Icon && <span className="pset-icon"><Icon size={16} /></span>}
                <div className="pset-titles">
                    <h3 className="pset-title">{title}</h3>
                    {subtitle && <p className="pset-sub">{subtitle}</p>}
                </div>
                {aside && <div className="pset-aside">{aside}</div>}
            </div>
            {children && <div className="pset-body">{children}</div>}
        </section>
    );
}
